import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  Assignment,
  ASSIGNMENT_TYPE,
  CreateAssignment,
  FindManyAssignment,
  FindOne,
  PaginateResult,
} from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { Observable } from 'rxjs';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class AssignmentService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, config: Configuration) {
    this.baseUrl = config.apiMainUrl + '/assignment';
  }

  create(body: CreateAssignment): Observable<Assignment> {
    return this.http.post<Assignment>(this.baseUrl, body);
  }

  find(
    queryParams: FindManyAssignment = {}
  ): Observable<PaginateResult<Assignment>> {
    const params = new HttpParams({
      fromObject: ObjectUtil.removeEmptyProperties(queryParams) as Params,
    });

    return this.http.get<PaginateResult<Assignment>>(this.baseUrl, { params });
  }

  findOneByReference(
    reference: string,
    type: ASSIGNMENT_TYPE,
    query: FindOne = {}
  ): Observable<Assignment> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<Assignment>(
      `${this.baseUrl}/type/${type}/refrence/${reference}`,
      {
        params,
      }
    );
  }
}
